import { useEffect, useState } from "react";
import Pagination from "./Pagination";
import NcImage from "componentsTemplate/NcImage/NcImage";
import perfilService from "../../services/PerfilService";
import { useNavigate } from "react-router-dom";

const people = [
  {
    id: 1,
    title: "Tokyo Fashion Week Is Making Itself Great Again",
    image:
      "https://images.unsplash.com/photo-1617059063772-34532796cdb5?ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=60",
    liveStatus: true,
    payment: "Not Applicable",
  },
  {
    id: 2,
    title: "Traveling Tends to Magnify All Human Emotions",
    image:
      "https://images.unsplash.com/photo-1622987437805-5c6f7c2609d7?ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw1fHx8ZW58MHx8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=60",
    liveStatus: true,
    payment: "Not Applicable",
  },
  {
    id: 3,
    title: "Interior Design: Hexagon is the New Circle in 2018",
    image:
      "https://images.unsplash.com/photo-1617201277988-f0efcc14e626?ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwxMHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=60",
    liveStatus: true,
    payment: "Not Applicable",
  },
  {
    id: 4,
    title: "Heritage Museums & Gardens to Open with New Landscape",
    image:
      "https://images.unsplash.com/photo-1622960748096-1983e5f17824?ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyMHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=60",
    liveStatus: true,
    payment: "Not Applicable",
  },
  {
    id: 5,
    title:
      "Man agrees to complete $5,000 Hereford Inlet Lighthouse painting job",
    image:
      "https://images.unsplash.com/photo-1617202227468-7597afc7046d?ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyNHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=60",
    liveStatus: false,
    payment: "Not Applicable",
  },
  {
    id: 6,
    title:
      "Denton Corker Marshall the mysterious black box is biennale pavilion",
    image:
      "https://images.unsplash.com/photo-1622978147823-33d5e241e976?ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwzM3x8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=60",
    liveStatus: true,
    payment: "Not Applicable",
  },
];

const Table = ({
  coluna1 = "Coluna 1",
  coluna2 = "Coluna 2",
  coluna3 = "Coluna 3",
  rota = "",
  acao = null,
  tipo = "",
  onlyView = false,
}: any) => {
  const [pagination, setPagination]: any = useState(null);
  const [lista, setLista]: any = useState([]);

  const urlBaseApi = process.env.REACT_APP_BACKEND_API_URL;

  const navigate = useNavigate();

  useEffect(() => {
    if (rota != "") {
      buscarInfo();
    }
  }, []);

  const buscarInfo = async (current_page = 1, per_page = 10) => {
    await perfilService
      .getList(rota, current_page, per_page)
      .then((list: any) => {
        setLista(list.data.data);
        setPagination({
          last_page: list.data.last_page,
          current_page: list.data.current_page,
          per_page: list.data.per_page,
        });
      })
      .catch((error: any) => {
        console.error(error);
      });
  };

  const formatarDataParaBR = (data: string) => {
    let dataFormatada = new Date(data);

    let dataString = dataFormatada.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    // let horaString = dataFormatada.toLocaleTimeString('pt-BR', {
    //   hour: '2-digit',
    //   minute: '2-digit'
    // });

    return `${dataString}`;
  };

  const exibirData = (item: any) => {
    if (tipo == "evento") {
      return formatarDataParaBR(item.initial_date);
    }

    if (tipo == "classificados" || tipo == "dicas" || tipo == "parceiros") {
      return formatarDataParaBR(item.created_at);
    }
  };

  const exibirImg = (item: any) => {
    if (tipo == "evento") {
      return (
        <NcImage
          containerClassName="flex-shrink-0 h-12 w-12 rounded-lg relative z-0 overflow-hidden lg:h-14 lg:w-14"
          src={
            item.logo_path != null
              ? urlBaseApi +
                "/storage/images/posts/events/logos/" +
                item.logo_path
              : "https://images.unsplash.com/photo-1617059063772-34532796cdb5?ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=60"
          }
          fill
          sizes="80px"
          alt="post"
        />
      );
    }

    if (tipo == "dicas") {
      return (
        <NcImage
          containerClassName="flex-shrink-0 h-12 w-12 rounded-lg relative z-0 overflow-hidden lg:h-14 lg:w-14"
          src={
            item.banner_path != null
              ? urlBaseApi +
                "/storage/images/posts/tips/banners/" +
                item.banner_path
              : "https://images.unsplash.com/photo-1617059063772-34532796cdb5?ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=60"
          }
          fill
          sizes="80px"
          alt="post"
        />
      );
    }

    if (tipo == "parceiros") {
      return (
        <NcImage
          containerClassName="flex-shrink-0 h-12 w-12 rounded-lg relative z-0 overflow-hidden lg:h-14 lg:w-14"
          src={
            item.logo_path != null
              ? urlBaseApi +
                "/storage/images/posts/partnerships/logos/" +
                item.logo_path
              : "https://images.unsplash.com/photo-1617059063772-34532796cdb5?ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwyfHx8ZW58MHx8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=60"
          }
          fill
          sizes="80px"
          alt="post"
        />
      );
    }
  };

  const exibirStatus = (status: any) => {
    if (status == 1) {
      return (
        <span className="px-2 inline-flex text-xs leading-5 font-medium rounded-full bg-green-100 text-green-800 lg:text-sm">
          Autorizado
        </span>
      );
    } else if (status == 2) {
      return (
        <span className="px-2 inline-flex text-xs leading-5 font-medium rounded-full bg-yellow-100 text-yellow-800 lg:text-sm">
          Recusado
        </span>
      );
    } else if (status == 3) {
      return (
        <span className="px-2 inline-flex text-xs leading-5 font-medium rounded-full bg-red-100 text-red-800 lg:text-sm">
          Pendente
        </span>
      );
    } else if (status == 4) {
      return (
        <span className="px-2 inline-flex text-xs leading-5 font-medium rounded-full bg-blue-100 text-blue-800 lg:text-sm">
          Revisado
        </span>
      );
    }
  };

  const buscarUrl = (item: any) => {
    if (tipo == "evento") {
      return "/evento-detalhes/" + item.id;
    }

    if (tipo == "dicas") {
      return "/dicas-detalhes/" + item.id;
    }

    if (tipo == "parceiros") {
      return "/parceiros/" + item.id;
    }

    if (tipo == "classificados") {
      return "/classificados/" + item.id;
    }
  };

  const redirectEdit = (item: any) => {
    if (tipo == "evento") {
      navigate("/editar-evento/" + item.id);
    }

    if (tipo == "dicas") {
      navigate("/editar-dica/" + item.id);
    }

    if (tipo == "parceiros") {
      navigate("/editar-parceria/" + item.id);
    }

    if (tipo == "classificados") {
      navigate("/editar-classificado/" + item.id);
    }
  }

  return (
    <div className="flex flex-col space-y-8">
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="py-2 align-middle inline-block min-w-full px-1 sm:px-6 lg:px-8">
          <div className="shadow dark:border dark:border-neutral-800 overflow-hidden sm:rounded-lg">
            <table className="min-w-full divide-y divide-neutral-200 dark:divide-neutral-800">
              <thead className="bg-neutral-50 dark:bg-neutral-800">
                <tr className="text-left text-xs font-medium text-neutral-500 dark:text-neutral-300 uppercase tracking-wider">
                  <th scope="col" className="px-6 py-3">
                    {coluna1}
                  </th>
                  <th scope="col" className="px-6 py-3">
                    {coluna2}
                  </th>
                  <th scope="col" className="px-6 py-3">
                    {coluna3}
                  </th>
                  
                  {
                    !onlyView && (
                      <th scope="col" className="px-6 py-3">
                        Ação
                      </th>
                    )
                  }
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-neutral-900 divide-y divide-neutral-200 dark:divide-neutral-800">
                  {
                    lista != null && lista.length > 0 ? (
                      <>
                        {lista.map((item: any) => (
                          <tr key={item.id}>
                            <td className="px-6 py-4">
                              <div className="flex items-center w-96 lg:w-auto max-w-md overflow-hidden">
                                {exibirImg(item)}

                                <div className="ml-4 flex-grow">
                                  <h2 className="inline-flex line-clamp-2 text-sm font-semibold  dark:text-neutral-300">
                                    <a href={buscarUrl(item)}> {item.name}</a>
                                  </h2>
                                </div>
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              {exibirStatus(item?.post?.post_status_id)}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-neutral-500 dark:text-neutral-400">
                              <span> {exibirData(item)}</span>
                            </td>
                            {
                              !onlyView && (
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium text-neutral-300">
                                  <span
                                    className="click text-primary-800 dark:text-primary-500 hover:text-primary-900"
                                    onClick={() => redirectEdit(item)}
                                  >
                                    Editar
                                  </span>
                                  {/* {` | `} */}
                                  {/* <a
                                    href="/#"
                                    className="text-rose-600 hover:text-rose-900"
                                  >
                                    Deletar
                                  </a> */}
                                </td>
                              )
                            }
                          </tr>
                        ))}
                      </>
                    ) : (
                      <tr>
                        <td colSpan={4} className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium text-neutral-300">
                          Não há registros
                        </td>
                      </tr>
                    )
                  }
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {pagination != null ? (
        <Pagination pagination={pagination} buscarInfo={buscarInfo} />
      ) : null}
    </div>
  );
};

export default Table;
